import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "policies-section my-4" };
const _hoisted_2 = { class: "card p-4" };
const _hoisted_3 = {
    key: 0,
    class: "loading-state"
};
const _hoisted_4 = {
    key: 1,
    class: "policies-grid"
};
const _hoisted_5 = { class: "policy-card" };
const _hoisted_6 = { class: "policy-content" };
const _hoisted_7 = {
    key: 0,
    class: "policy-text"
};
const _hoisted_8 = {
    key: 1,
    class: "policy-text text-muted"
};
const _hoisted_9 = ["href"];
const _hoisted_10 = { class: "policy-card" };
const _hoisted_11 = { class: "policy-content" };
const _hoisted_12 = {
    key: 0,
    class: "policy-text"
};
const _hoisted_13 = {
    key: 1,
    class: "policy-text text-muted"
};
const _hoisted_14 = { class: "policy-card" };
const _hoisted_15 = { class: "policy-content" };
const _hoisted_16 = {
    key: 0,
    class: "policy-text"
};
const _hoisted_17 = {
    key: 1,
    class: "policy-text text-muted"
};
const _hoisted_18 = { class: "policy-card" };
const _hoisted_19 = { class: "policy-content" };
const _hoisted_20 = {
    key: 0,
    class: "payment-methods"
};
const _hoisted_21 = {
    key: 1,
    class: "policy-text text-muted"
};
const _hoisted_22 = {
    key: 2,
    class: "payment-notes"
};
const _hoisted_23 = {
    key: 2,
    class: "no-data-state"
};
import { computed, ref, onMounted, watch } from 'vue';
import { getLocationPolicies } from '@/services/location-policies.service';
export default /*@__PURE__*/ _defineComponent({
    __name: 'GastronomyPoliciesSection',
    props: {
        locationId: {},
        policies: {},
        payments: {}
    },
    emits: ["policiesLoaded"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const policyData = ref(null);
        const loading = ref(false);
        const hasPolicies = ref(false);
        const emit = __emit;
        // Exponer hasPolicies para que el componente padre pueda verificar si hay políticas
        __expose({
            hasPolicies
        });
        // Computed properties para formatear los datos
        const reservationText = computed(() => {
            if (policyData.value?.reservation_notes) {
                return policyData.value.reservation_notes;
            }
            return props.policies?.reservations || null;
        });
        const cancellationText = computed(() => {
            if (policyData.value?.cancellation_policy) {
                let text = policyData.value.cancellation_policy;
                if (policyData.value.cancellation_deadline_hours) {
                    const hours = policyData.value.cancellation_deadline_hours;
                    const days = Math.floor(hours / 24);
                    const remainingHours = hours % 24;
                    let deadlineText = '';
                    if (days > 0) {
                        deadlineText = `${days} día${days > 1 ? 's' : ''}`;
                        if (remainingHours > 0) {
                            deadlineText += ` y ${remainingHours} hora${remainingHours > 1 ? 's' : ''}`;
                        }
                    }
                    else {
                        deadlineText = `${hours} hora${hours > 1 ? 's' : ''}`;
                    }
                    text = `Cancelación con ${deadlineText} de anticipación. ${text}`;
                }
                return text;
            }
            return props.policies?.cancellation || null;
        });
        const hoursText = computed(() => {
            if (policyData.value?.opening_hours) {
                let text = policyData.value.opening_hours;
                if (policyData.value.days_closed && policyData.value.days_closed !== 'Ninguno') {
                    text += `. Días cerrado: ${policyData.value.days_closed}`;
                }
                return text;
            }
            return props.policies?.hours || null;
        });
        const paymentMethods = computed(() => {
            if (policyData.value) {
                const methods = [];
                if (policyData.value.accepts_cash)
                    methods.push('Efectivo');
                if (policyData.value.accepts_credit_card)
                    methods.push('Tarjeta de crédito');
                if (policyData.value.accepts_debit_card)
                    methods.push('Tarjeta de débito');
                if (policyData.value.accepts_bank_transfer)
                    methods.push('Transferencia bancaria');
                if (policyData.value.accepts_digital_wallet)
                    methods.push('Billetera digital');
                return methods;
            }
            return props.payments || [];
        });
        const getPaymentIcon = (method) => {
            const icons = {
                'Efectivo': 'fas fa-money-bill-wave',
                'Tarjeta de crédito': 'fas fa-credit-card',
                'Tarjeta de débito': 'fas fa-credit-card',
                'Transferencia bancaria': 'fas fa-university',
                'Billetera digital': 'fas fa-wallet'
            };
            return icons[method] || 'fas fa-money-bill';
        };
        const loadPolicies = async () => {
            if (!props.locationId) {
                // Si no hay locationId pero hay props legacy, considerar que hay políticas
                const hasLegacyPolicies = !!(props.policies || props.payments);
                policyData.value = null;
                hasPolicies.value = hasLegacyPolicies;
                emit('policiesLoaded', hasLegacyPolicies);
                return;
            }
            loading.value = true;
            try {
                const data = await getLocationPolicies(props.locationId);
                policyData.value = data;
                hasPolicies.value = !!data;
                emit('policiesLoaded', hasPolicies.value);
            }
            catch (error) {
                console.error('Error loading location policies:', error);
                policyData.value = null;
                hasPolicies.value = false;
                emit('policiesLoaded', false);
            }
            finally {
                loading.value = false;
            }
        };
        // Cargar políticas cuando cambie el locationId
        watch(() => props.locationId, () => {
            loadPolicies();
        }, { immediate: true });
        onMounted(() => {
            if (props.locationId) {
                loadPolicies();
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "section-title" }, [
                        _createElementVNode("i", { class: "fas fa-file-alt icon" }),
                        _createTextVNode("Políticas ")
                    ], -1)),
                    (loading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[0] || (_cache[0] = [
                                _createElementVNode("div", { class: "spinner" }, null, -1),
                                _createElementVNode("p", { class: "text-muted" }, "Cargando políticas...", -1)
                            ]))]))
                        : (policyData.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "policy-header" }, [
                                        _createElementVNode("i", { class: "fas fa-calendar-check icon" }),
                                        _createElementVNode("h4", { class: "policy-title" }, "Reservas")
                                    ], -1)),
                                    _createElementVNode("div", _hoisted_6, [
                                        (reservationText.value)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(reservationText.value), 1))
                                            : (_openBlock(), _createElementBlock("p", _hoisted_8, "Consultar condiciones de reserva")),
                                        (policyData.value.reservation_link)
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 2,
                                                href: policyData.value.reservation_link,
                                                target: "_blank",
                                                rel: "noopener",
                                                class: "policy-link"
                                            }, [...(_cache[1] || (_cache[1] = [
                                                    _createElementVNode("i", { class: "fas fa-external-link-alt" }, null, -1),
                                                    _createTextVNode(" Reservar ahora ", -1)
                                                ]))], 8, _hoisted_9))
                                            : _createCommentVNode("", true)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_10, [
                                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "policy-header" }, [
                                        _createElementVNode("i", { class: "fas fa-times-circle icon" }),
                                        _createElementVNode("h4", { class: "policy-title" }, "Cancelación")
                                    ], -1)),
                                    _createElementVNode("div", _hoisted_11, [
                                        (cancellationText.value)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(cancellationText.value), 1))
                                            : (_openBlock(), _createElementBlock("p", _hoisted_13, "Consultar condiciones de cancelación"))
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_14, [
                                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "policy-header" }, [
                                        _createElementVNode("i", { class: "fas fa-clock icon" }),
                                        _createElementVNode("h4", { class: "policy-title" }, "Horarios")
                                    ], -1)),
                                    _createElementVNode("div", _hoisted_15, [
                                        (hoursText.value)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(hoursText.value), 1))
                                            : (_openBlock(), _createElementBlock("p", _hoisted_17, "Consultar horarios"))
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_18, [
                                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "policy-header" }, [
                                        _createElementVNode("i", { class: "fas fa-credit-card icon" }),
                                        _createElementVNode("h4", { class: "policy-title" }, "Formas de pago")
                                    ], -1)),
                                    _createElementVNode("div", _hoisted_19, [
                                        (paymentMethods.value.length > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paymentMethods.value, (method, index) => {
                                                    return (_openBlock(), _createElementBlock("span", {
                                                        key: index,
                                                        class: "payment-badge"
                                                    }, [
                                                        _createElementVNode("i", {
                                                            class: _normalizeClass(getPaymentIcon(method))
                                                        }, null, 2),
                                                        _createTextVNode(" " + _toDisplayString(method), 1)
                                                    ]));
                                                }), 128))
                                            ]))
                                            : (_openBlock(), _createElementBlock("p", _hoisted_21, "Consultar métodos disponibles")),
                                        (policyData.value.payment_notes)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_22, [
                                                _cache[5] || (_cache[5] = _createElementVNode("i", { class: "fas fa-info-circle" }, null, -1)),
                                                _createTextVNode(" " + _toDisplayString(policyData.value.payment_notes), 1)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ])
                                ])
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_23, [...(_cache[7] || (_cache[7] = [
                                    _createElementVNode("i", { class: "fas fa-info-circle" }, null, -1),
                                    _createElementVNode("p", { class: "text-muted" }, "No hay información de políticas disponible", -1)
                                ]))]))
                ])
            ]));
        };
    }
});
